import React, { PureComponent } from 'react';
import { includes } from 'lodash';

import _ from 'lodash';
import $ from 'jquery';
import * as deviceInfoService from '../utils/general/deviceInfoService';

interface IFullScreenPopupProps {
    bodySource: any;
    modalWindowStyle?: any;
    modalBodyStyle?: any;
}

interface IFullScreenPopupStates {
    modalWindowStyle: any;
    modalBodyStyle: any;
}

class FullScreenPopup extends PureComponent<IFullScreenPopupProps, IFullScreenPopupStates> {
    public modalBodyRef: any = React.createRef();
    public modalWindowRef: any = React.createRef();
    public bodyObj: any = document.querySelector('body');
    
    constructor(props: IFullScreenPopupProps) {
        super(props);
        const _modalWindowStyle = {
        };
        const _modalBodyStyle = {
            backgroundColor: 'white',
            width: '100%',
        };
        if (!_.isEmpty(this.props.modalWindowStyle)) {
            Object.assign(_modalWindowStyle, this.props.modalWindowStyle);
        }
        if (!_.isEmpty(this.props.modalBodyStyle)) {
            Object.assign(_modalBodyStyle, this.props.modalBodyStyle);
        }
        this.state = {
            modalWindowStyle: _modalWindowStyle,
            modalBodyStyle: _modalBodyStyle
        };
    }

    public closeModal(event: any) {
        // Important!!! the close function can through bubbling propagation, So don't need write any code in here!
    }

    public componentDidMount() {
        setTimeout(() => {
            // const modalBodyHeight = this.modalBodyRef.current.offsetHeight;
            this.modalBodyRef.current.style.maxHeight = ($(window) as any).height() - 46 + "px";
            const popupTableEle = $('#modal-root>div.modal-popup-class .modalWindow.modal-fullscreen .rendition-modal-window div.tableWrapper table.x-rsch-table');
            if (!!popupTableEle) {
                this.calculateIframePopupTableWidth();
                $(window).on('resize.renditionModalWindow.popupTableResizer', _.debounce(_.bind(this.calculateIframePopupTableWidth, this), 10));
                $(window).on('orientationchange.renditionModalWindow.popupTableResizer', _.debounce(_.bind(this.calculateIframePopupTableWidth, this), 10));
            }
        });
    }

    public calculateIframePopupTableWidth() {
        const modalPopupEle = $('#modal-root>div.modal-popup-class');
        const mainPageWidth =  ($('#mainPage') as any).width();
        if (this.modalBodyRef.current == null) {
            return;
        }
        if (deviceInfoService.isDeviceScreenType()) {
            // this.modalBodyRef.current.style.width = mainPageWidth - 10 + "px";
            modalPopupEle.css('width', mainPageWidth - 10 + "px");
        } else {
            // this.modalBodyRef.current.style.width = mainPageWidth - 100 + "px";
            modalPopupEle.css('width', mainPageWidth - 100 + "px");
        }
    }

    public componentWillUnmount() {
        const popupTableEle = $('#modal-root>div.modal-popup-class .modalWindow.modal-fullscreen .rendition-modal-window div.tableWrapper table.x-rsch-table');
        if (!!popupTableEle) {
            $(window).off('resize.renditionModalWindow.popupTableResizer', _.debounce(_.bind(this.calculateIframePopupTableWidth, this), 10));
            $(window).off('orientationchange.renditionModalWindow.popupTableResizer', _.debounce(_.bind(this.calculateIframePopupTableWidth, this), 10));
        }
    }

    public enterPressedCloseModal(event: any) {
        const key = event.keyCode || event.which;
        if (key === 13 || key === 27 || key === 32) {
            $('#modalClose').click();
        }
    }
    public getIdForKeyDataChanges(){
        return (includes(this.props.bodySource, 'Key Rating')) ? 'keyDataChanges' : '';
    }

    public render() {
        const { bodySource } = this.props;
                return (
            <React.Fragment>
                <div className="modalWindow modal-fullscreen">
                    <div className="rendition-modal-window" ref={this.modalWindowRef} style={this.state.modalWindowStyle}>
                        <div className="modal-header">
                            <span style={{ width: '100%' }}>{}</span>
                            <span id="modalClose"
                                onKeyPress={(e: any) => this.enterPressedCloseModal(e)}
                                onClick={(e) => this.closeModal(e)}
                                aria-label="Close Dialog"
                                tabIndex={0}
                                role="button"
                                className="modal-icon-close">
                            </span>
                            <span style={{ clear: 'both' }}></span>
                        </div>
                        <div ref={this.modalBodyRef} className="modal-body full_screen_modal modal-body-height" id={this.getIdForKeyDataChanges()} style={this.state.modalBodyStyle}>
                            {typeof bodySource === 'string' &&
                                <div dangerouslySetInnerHTML={{ __html: bodySource }} />
                            }
                            {typeof bodySource === "object" &&
                                bodySource
                            }
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop in" style={{ zIndex: -1 }}></div>
            </React.Fragment>
        );
    }
}

export default FullScreenPopup;
